import { getAccountId } from '@seek/adv-account-selection';

import { authenticationStatuses } from 'src/constants/taxonomy';
import type { Store } from 'src/store/types';

export const addStoreListeners = ({ store }: { store: Store }) => {
  store.ssoClient.getUniqueId().then((uniqueUserId) => {
    if (uniqueUserId) {
      store.setState({
        authenticationStatus: authenticationStatuses.AUTHENTICATED,
      });
    }
    store.setState({ ssoLoaded: true });
  });

  const accountId = getAccountId();

  store.setState({
    selectedAdvertiserAccountId: accountId,
  });
};
